// frontend/src/pages/AdminLayout.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLayout = ({ children, activePage, pageTitle, breadcrumbs = [] }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('hopeSaccoUser');
    if (!storedUser) {
      navigate('/login');
      return;
    }
    setUser(JSON.parse(storedUser));
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.clear();
      navigate('/login');
    }
  };

  return (
    <div className="admin-dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-icon">$</span>
            <span className="logo-text">SaccoTeck</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/dashboard'); }} className={`nav-item ${activePage === 'dashboard' ? 'active' : ''}`}>
            <span className="nav-icon">📊</span>
            <span className="nav-text">Dashboard</span>
          </a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/members'); }} className={`nav-item ${activePage === 'members' ? 'active' : ''}`}>
            <span className="nav-icon">👥</span>
            <span className="nav-text">Members</span>
          </a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/apply-loan'); }} className={`nav-item ${activePage === 'apply' ? 'active' : ''}`}>
            <span className="nav-icon">💵</span>
            <span className="nav-text">Apply Loan</span>
          </a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/loans/import-historical'); }} className={`nav-item ${activePage === 'import-historical' ? 'active' : ''}`}>
            <span className="nav-icon">📥</span>
            <span className="nav-text">Import Historical Loans</span>
          </a>

          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/reports'); }} className={`nav-item ${activePage === 'reports' ? 'active' : ''}`}>
            <span className="nav-icon">📈</span>
            <span className="nav-text">Reports</span>
          </a>
          {/* Member Statement — replaced by Members Statement (Merged View) */}
          {/* <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/reports/member-statement'); }} className={`nav-item ${activePage === 'member-statement' ? 'active' : ''}`}>
            <span className="nav-icon">📄</span>
            <span className="nav-text">Member Statement</span>
          </a> */}
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/reports/merged-statement'); }} className={`nav-item ${activePage === 'merged-statement' ? 'active' : ''}`}>
            <span className="nav-icon">🔀</span>
            <span className="nav-text">Members Statement</span>
          </a>
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/reports/monthly-overview'); }} className={`nav-item ${activePage === 'monthly-overview' ? 'active' : ''}`}>
            <span className="nav-icon">📅</span>
            <span className="nav-text">Monthly Overview</span>
          </a>

          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/monthly-processing'); }} className={`nav-item ${activePage === 'processing' ? 'active' : ''}`}>
            <span className="nav-icon">📄</span>
            <span className="nav-text">Monthly Processing</span>
          </a>

          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/members/manage-shares'); }} className={`nav-item ${activePage === 'manage-shares' ? 'active' : ''}`}>
            <span className="nav-icon">💹</span>
            <span className="nav-text">Manage Shares</span>
          </a>
          
          <a href="#" onClick={(e) => { e.preventDefault(); navigate('/admin/users'); }} className={`nav-item ${activePage === 'users' ? 'active' : ''}`}>
            <span className="nav-icon">👤</span>
            <span className="nav-text">Users</span>
          </a>

          {/* How To — distinct style */}
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigate('/admin/how-to'); }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              margin: '12px 12px 4px',
              padding: '12px 16px',
              borderRadius: 10,
              background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: 14,
              boxShadow: activePage === 'how-to'
                ? '0 0 18px rgba(79,70,229,0.8)'
                : '0 0 10px rgba(79,70,229,0.4)',
              border: '1px solid rgba(255,255,255,0.3)',
              transition: 'all 0.3s ease',
            }}
          >
            <span style={{ fontSize: 20 }}>🎬</span>
            <span>How To</span>
            <span style={{
              marginLeft: 'auto',
              background: 'rgba(255,255,255,0.25)',
              borderRadius: 20,
              padding: '1px 8px',
              fontSize: 10,
              fontWeight: 800,
              letterSpacing: 0.5,
            }}>NEW</span>
          </a>


        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <span className="nav-icon">↵</span>
            <span className="nav-text">Logout</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        {pageTitle && (
          <div className="page-header">
            <div className="header-left">
              <h1>{pageTitle}</h1>
              {breadcrumbs.length > 0 && (
                <div className="breadcrumb">
                  {breadcrumbs.map((crumb, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && <span className="separator">›</span>}
                      {crumb.link ? (
                        <span onClick={() => navigate(crumb.link)} style={{ cursor: "pointer" }}>
                          {crumb.label}
                        </span>
                      ) : (
                        <span className="current">{crumb.label}</span>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
